import api from "../Api";
import routes from "../constants/ApiRoutesConstants";

export default async function GetRecentActivity(params) {
  const res = await api.get(routes.GET_RECENT_ACTIVITY, { params: params });

  return res;
}
